/**
 * Отдельный vuex модуль для взаимодействия по schedules/-API
 */


// actions для crowds. Вызов действия начинать с "schedule/"
export const ACTION_LOAD_SCHEDULES_LIST = "LOAD_SCHEDULES_LIST";
export const ACTION_CREATE_SCHEDULE = "CREATE_SCHEDULE";
export const ACTION_DELETE_SCHEDULE = "DELETE_SCHEDULE";

/**
 * Дни недели.
 *
 */
export const DAYS_OF_WEEK = Object.freeze([
  {label: 'ПН', value: 0},
  {label: 'ВТ', value: 1},
  {label: 'СР', value: 2},
  {label: 'ЧТ', value: 3},
  {label: 'ПТ', value: 4},
  {label: 'СБ', value: 5},
  {label: 'ВС', value: 6},
]);

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    /**
     * Загрузка списка расписаний.
     *
     * @param {Array.<String>} camerasNumber
     * @param {Array.<String>} scheduleType
     */
    async [ACTION_LOAD_SCHEDULES_LIST](context, [cameraNumber, scheduleType]) {
      try {
        const response = await this.getters.ajaxClient.post("/v0/schedule/", {
          schedule_type: scheduleType,
          camera_number: cameraNumber
        });
        return response.data;
      } catch {
        return [];
      }
    },
    /**
     * Удаление расписания.
     *
     */
    async [ACTION_DELETE_SCHEDULE](context, [scheduleId]) {
      try {
        await this.getters.ajaxClient.post("/v0/schedule/delete", {
          schedule_id: scheduleId,
          confirm: true
        });
      } catch {
        return [];
      }
    },
    /**
     * Создание экземпляра расписания.
     *
     * @param {Array.<String>} camerasNumber
     * @param {Array.<String>} scheduleType
     */
    async [ACTION_CREATE_SCHEDULE](context, {cameraNumber, scheduleType, schedule}) {
      try {
        const settings = [];
        // Мапа "ПН" → 0 и т.д.
        const labelToDay = DAYS_OF_WEEK.reduce((acc, day) => {
          acc[day.label] = day.value;
          return acc;
        }, {});
        // Преобразуем дни в нужный формат
        schedule.days.forEach(label => {
          const day_of_week = labelToDay[label];
          if (day_of_week !== undefined) {
            settings.push({
              day_of_week,
              start_time: schedule.from,
              end_time: schedule.to,
              is_active: true,
            });
          }
        });
        const payload = {
          schedule_type: scheduleType,
          camera_number: cameraNumber,
          settings,
        };
        const response = await this.getters.ajaxClient.post("/v0/schedule/create/", payload);
        return response;
      } catch (e) {
        console.error("Ошибка при создании расписания:", e);
        throw e;
      }
    },
  },
};
